import AbstractRequestTask from "../AbstractRequestTask";
import getAppConfig from "../../../config/appConfig";
import DeviceStorage from "../../../components/DeviceStorage/DeviceStorage";
import {ENABLE_MODAL_RETRIES} from '../../RequestManagerConstants';
import AAF from "src/AAF/AAF";
import { EPG_VERSION_TTL } from "../../../AAF/Resilence/TTLConstants";
import store from '../../../store';

const TTLItem = EPG_VERSION_TTL;
class LevelRibbonTask extends AbstractRequestTask {
  constructor(uri, params, module_version = 'v2') {
    super();

    this.uri = uri;
    this.params = params;
    if (this.params.node_id === null) {
      delete this.params.node_id;
    }
    this.version = 'v2';
    this.module_version = module_version
  }

  getHeaders() {
    return {};
  }

  getUrl() {
    return getAppConfig().end_point_middleware + `${this.version}/` + this.uri;
  }

  getParams() {
    const params = super.getParams();
    const type = AAF.AdsUtils.getUserType();
    if (type) params.type = type;
    params.module_version = this.module_version;
    AAF.TTLUtil.verifyTTLItem(TTLItem, () => { AAF.TTLUtil.setEpgVersion(); }, 'LevelRibbonTask[getParams]');
    const epg_version = DeviceStorage.getItem('epgVersion');
    const user = store.getState().user;
    const lasttouch = user && user.lasttouch ? user.lasttouch.purchased : false;
    if (lasttouch) {
      params.lasttouch = lasttouch;
    }
    if(epg_version){
      params.epg_version = epg_version;
    }
    return Object.assign({}, params, this.params);
  }

  success(data, b) {
    this.resolve(data);
  }

  getShowErrorModal(){
    return ENABLE_MODAL_RETRIES;
  }
}

export default LevelRibbonTask;



// WEBPACK FOOTER //
// ./src/requests/tasks/cms/LevelRibbonTask.js